import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoices-history',
  templateUrl: './invoices-history.component.html',
  styleUrls: ['./invoices-history.component.scss']
})
export class InvoicesHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
